import { Dashboard } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';

import LayoutSelectorModal from './LayoutSelectorModal';
import { LayoutOption } from './types';

interface LayoutSelectorProps<T extends string> {
  currentLayout?: T;
  layoutOptions: LayoutOption<T>[];
  onLayoutChange: (layoutTemplate: T) => void;
}

function LayoutSelector<T extends string>({
  currentLayout,
  layoutOptions,
  onLayoutChange,
}: LayoutSelectorProps<T>) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSelectLayout = (layoutTemplate: T) => {
    onLayoutChange(layoutTemplate);
    handleClose();
  };

  return (
    <>
      <Tooltip title='Change Dashboard Layout'>
        <IconButton onClick={handleOpen} color='primary'>
          <Dashboard />
        </IconButton>
      </Tooltip>

      <LayoutSelectorModal<T>
        open={open}
        onClose={handleClose}
        currentLayout={currentLayout}
        layoutOptions={layoutOptions}
        onSelectLayout={handleSelectLayout}
      />
    </>
  );
}

export default LayoutSelector;
